// DS2.5.1 includes DS1.7 (Notification/Counter)
import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import c from 'classnames';
import IconButton from '../IconButton';
import shortenNumber from '../../../utils/shortenNumber';
import s from './IconButtonWithNotification.scss';
export function limitNumber(number) {
    return number > 999 ? shortenNumber(number, 0, Math.floor) : `${number}`;
}
const IconButtonWithNotification = (_param)=>{
    var { className , iconButtonClassName , numberClassName , count , notificationColor ='red'  } = _param, iconButtonProps = _object_without_properties(_param, [
        "className",
        "iconButtonClassName",
        "numberClassName",
        "count",
        "notificationColor"
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['icon-button-wrapper'], className)
    }, /*#__PURE__*/ React.createElement(IconButton, _extends({}, iconButtonProps, {
        className: c(s['root'], iconButtonClassName)
    })), !!count && /*#__PURE__*/ React.createElement("span", {
        className: c(s['number'], s[notificationColor], numberClassName)
    }, limitNumber(count)));
};
IconButtonWithNotification.displayName = 'IconButtonWithNotification';
export default IconButtonWithNotification;
